/**
 * Ion Next value lookups (admin page only).
 *
 * The chips label themselves: MarkdownRenderer's `chipProvenance` hands the
 * artifact's `provenance` to DataValueChip (chat/chipProvenance.js has the
 * labels). This module only resolves a `[[V:N]]` citation against the Ion
 * Next page's OWN messages, so a chip citing an earlier Ion Next turn never
 * resolves against the customer conversation in chatStore.
 */
import { extractValueByRef } from '../../../state/chatStore.js';

/** The artifact of a tool call, in either envelope shape. */
export function unwrapArtifact(call) {
  if (!call || !call.output) return null;
  if (call.output.artifact_type) return call.output;
  if (call.output.result && call.output.result.artifact_type) return call.output.result;
  return null;
}

/**
 * The chip props of value `ref` across `messages` (DataValueChip shape, plus
 * `provenance` for a single-value chip), or null.
 */
export function findValueInMessages(messages, ref) {
  if (!Number.isInteger(ref)) return null;
  for (const m of messages || []) {
    for (const call of m.toolCalls || []) {
      const v = extractValueByRef(call, ref);
      if (!v) continue;
      const a = unwrapArtifact(call);
      const single = a && (a.artifact_type === 'data_value' || a.artifact_type === 'data_string') && a.ref === ref;
      return single && a.provenance ? { ...v, provenance: a.provenance } : v;
    }
  }
  return null;
}
